import { baseConfiguration } from 'utils/constants/customizer';

export const STY903 = {
  ...baseConfiguration,
  name: 'stuffed_jacket',
  angleName: 'stuffed_jacket',
};
